export default __webpack_public_path__ + "static/media/hippostores.44e3a7e6.png";